import { useState } from "react";
import { Box, Tabs, Tab } from "@mui/material";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import BusinessIcon from "@mui/icons-material/Business";
import { ResidentialServices } from "./tabs/ResidentialServices";
import { CommercialServices } from "./tabs/CommercialServices";
import { colors } from "../ui/colors";
import { useServiceConfiguration } from "./hooks/useServiceConfiguration";
import { useEffect } from "react";
import { SnackbarAlert } from "../common/SnackbarAlert";
import { useSnackbar } from "../common/snackbar/useSnackbar";

function TabPanel({ children, value, index }) {
  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      sx={{ flex: 1, p: 2, width: "100%" }}
    >
      {value === index && <Box>{children}</Box>}
    </Box>
  );
}

export function ManageServices() {
  const [selectedTab, setSelectedTab] = useState(0);
  const { closeSnackbar, showSnackbar, snackbar } = useSnackbar()



  const handleTabChange = (_e, newValue) => {
    setSelectedTab(newValue);
  };

  //Llamada al API para servicios
  const { getAllServices, services, updateSelectedServices } = useServiceConfiguration()

  useEffect(() => {
    getAllServices()
  }, [])

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        variant="fullWidth"
        sx={{
          borderBottom: `2px solid ${colors.orange[100]}`,
          "& .MuiTabs-indicator": {
            backgroundColor: colors.orange.base,
            height: 3,
            borderRadius: "2px",
            boxShadow: `0 2px 6px ${colors.orange[200]}`,
          },
          minHeight: 65,
        }}
      >
        <Tab
          icon={<HomeWorkIcon />}
          iconPosition="start"
          label="Residential"
          sx={{
            textTransform: "none",
            fontWeight: 500,
            fontSize: "0.95rem",
            borderRadius: 2,
            color: selectedTab === 0 ? colors.orange.base : colors.gray[500],
            "&.Mui-selected": {
              color: colors.orange[700],
              bgcolor: colors.orange[50],
            },
          }}
        />
        <Tab
          icon={<BusinessIcon />}
          iconPosition="start"
          label="Commercial"
          sx={{
            textTransform: "none",
            fontWeight: 500,
            fontSize: "0.95rem",
            borderRadius: 2,
            color: selectedTab === 1 ? colors.orange.base : colors.gray[500],
            "&.Mui-selected": {
              color: colors.orange[700],
              bgcolor: colors.orange[50],
            },
          }}
        />
      </Tabs>


      {/* Contenido */}
      <TabPanel value={selectedTab} index={0}>
        <ResidentialServices services={services.residential} updateSelectedServices={updateSelectedServices} showSnackbar={showSnackbar} />
      </TabPanel>

      <TabPanel value={selectedTab} index={1}>
        <CommercialServices services={services.commercial} updateSelectedServices={updateSelectedServices} showSnackbar={showSnackbar} />
      </TabPanel>


      <SnackbarAlert
        openState={snackbar.open}
        setOpenState={(open) => {
          if (!open) closeSnackbar();
        }}
        severity={snackbar.severity}
        message={snackbar.message}
        position="bottom-left"
        scope="local"
      />
    </Box>
  );
}
